import React, {
  useEffect,
  useRef,
  forwardRef,
  useImperativeHandle,
} from "react";
import NominalShareCapitalTab from "components/PLCTABS/NominalShareCapitalTab";
import { useSelector, useDispatch } from "react-redux";
import { getShareAuthorizationsAsync } from "state/slices/shareCapitalAuthorization";
import { getShareAllotmentsAsync } from "state/slices/shareCapitalAllotment";
import UnallotedSharesContext from "context/UnallotedSharesContext";

const ShareCapital = forwardRef((props, ref) => {
  const dispatch = useDispatch();
  const {
    company: {
      nominalShares: allNominalShares,
      _id: companyId,
      type: entityType,
    },
  } = useSelector((state) => state.companyDashboardSlice);

  const nominalShares = (allNominalShares || []).filter(
    (share) => share.sharesNumber && share.sharesNumber !== 0
  );

  const { shares: authorizations } = useSelector(
    (state) => state.shareAuthorizationSlice
  );

  const nominalTabRef = useRef();
  const { company } = useSelector((state) => state.companySlice);
  const { comments } = useSelector((state) => state.commentsSlice);

  const shareInformationComments = comments.filter(
    (comment) => comment.formName === "shareInformation"
  );

  const handleSaveComment = async (data) => {};

  useImperativeHandle(ref, () => ({
    submit: () => {
      return nominalTabRef.current?.submit();
    },
  }));

  useEffect(() => {
    if (companyId) {
      dispatch(getShareAuthorizationsAsync(companyId));
      dispatch(getShareAllotmentsAsync(companyId));
    }
  }, [dispatch, companyId]);
  const isInChangesModule = true;
  return (
    <UnallotedSharesContext.Provider value={{ isInChangesModule }}>
      <NominalShareCapitalTab
        ref={nominalTabRef}
        nominalShares={nominalShares}
        company={companyId}
        isInManualUpdate={props?.isInManualUpdate}
        changeType={props}
        handleGoBack={props.handleGoBack}
        handleGoForward={props.handleGoForward}
        entityType={entityType}
        authorizations={authorizations}
        showAddCommentColumn={props?.showAddCommentColumn || false}
        handleSaveComment={handleSaveComment}
        shareInformationComments={shareInformationComments}
      />
    </UnallotedSharesContext.Provider>
  );
});

export default ShareCapital;
